import { NavLink,useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { toast } from "react-toastify";

//import { useAuth } from "../../components/AuthContext";
 

export default function MobileDrawer({ open, onClose }) {
  const navigate = useNavigate();

const handleLogout = () => {
  toast.dismiss(); // close any old toasts

  toast(
    ({ closeToast }) => (
      <div className="w-[260px] items-center">
        <p className="text-sm font-semibold text-gray-700 mb-4 text-center">
          Are you sure you want to logout?
        </p>

        <div className="flex justify-center gap-3">
          <button
            onClick={() => {
              localStorage.removeItem("auth");
              closeToast();
              navigate("/pos/login", { replace: true });
            }}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-1.5 rounded text-sm"
          >
            Yes, Logout
          </button>

          <button
            onClick={closeToast}
            className="bg-gray-200 hover:bg-gray-300 px-4 py-1.5 rounded text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    ),
    {
      closeButton: false,
      icon: false,
      autoClose: false,
      hideProgressBar: true,
      className: "rounded-lg shadow-lg p-4",
    }
  );
};


  //const role = localStorage.getItem("role");
  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
  const role = (auth.role || "").toLowerCase().trim();

  const ADMIN_MENU = [
    { label: "Orders", path: "/pos/orders" },
    { label: "Sales Persons", path: "/pos/sales-persons" },
    { label: "Barcode", path: "/pos/barcode" },
    { label: "QR Settings", path: "/pos/qr" },
    { label: "Profile", path: "/pos/profile" },
  ];

  const SALES_MENU = [
    { label: "Sell", path: "/pos/sell" },
    { label: "Orders", path: "/pos/orders" },
    { label: "Profile", path: "/pos/profile" },
  ];

  const MENU = role === "admin" ? ADMIN_MENU : SALES_MENU;

  if (!open) return null;

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/40 z-40" onClick={onClose} />

      {/* Drawer */}
      <aside className="fixed top-0 left-0 h-full w-64 bg-white z-50 shadow-lg">
        <div className="p-4 border-b flex justify-between items-center">
          <span className="font-semibold">Menu</span>
          <button onClick={onClose}>
            <X />
          </button>
        </div>

        <nav className="p-4 space-y-2">
          {MENU.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={onClose} // closes drawer on navigation
              className={({ isActive }) =>
                `block px-3 py-2 rounded ${
                  isActive ? "bg-blue-100 text-blue-600" : "hover:bg-gray-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}

          <hr className="my-3" />

          <button
            onClick={handleLogout}
            className="w-full text-left px-3 py-2 rounded hover:bg-red-100 text-red-600 font-medium"
          >
            Logout
          </button>
        </nav>
      </aside>
    </>
  );
}
